export const JOURNEY_LABEL_FLYBITS_INTERNAL = 'flybits-internal';
